import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Container,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultFooter from "examples/Footers/DefaultFooter";
import MKBox from "components/MKBox";
import rockBand from "assets/images/rock-band-bgg.png";
import Autocomplete from "@mui/material/Autocomplete";
import dayjs from "dayjs";

import Slide from "@mui/material/Slide";
import MKAlert from "components/MKAlert";
import MKTypography from "components/MKTypography";
import emailjs from "emailjs-com";

const cities = [
  "Delhi",
  "Noida",
  "Gurugram",
  "Mumbai",
  "Manali",
  "Chandigarh",
  "Jaipur",
  "Pune",
  "Bangalore",
  "Ahmedabad",
  "Hyderabad",
  "Kolkata",
  "Chennai",
];

const steps = [
  "Event Details",
  "Band Setup",
  "Guests Count",
  "Occasion Type",
  "Venue Type",
  "Contact Details",
];

const SearchArtists = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setTimeout(() => setSuccess(false), 3000);
  }, [success]);

  const [formData, setFormData] = useState({
    location: "",
    eventDate: "",
    bandSetup: "",
    guests: "",
    occasion: "",
    venueType: "",
    name: "",
    phone: "",
  });

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const validateStep = () => {
    const requiredFields = [
      ["location", "eventDate"],
      ["bandSetup"],
      ["guests"],
      ["occasion"],
      ["venueType"],
      ["name", "phone"],
    ];
    return requiredFields[activeStep].every(
      (field) => formData[field].trim() !== ""
    );
  };

  const handleNext = () => {
    if (!validateStep())
      return alert("Please complete this step before continuing.");
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();

    const messageData = {
      ...formData,
      submittedTime: new Date().toLocaleString(),
    };

    emailjs
      .send(
        "service_xlukffd",
        "template_bm7jhlm",
        messageData,
        "HYpNCjCXS-NiZBGXa"
      )
      .then(() => {
        setSuccess(true);
        setFormData({
          location: "",
          eventDate: "",
          bandSetup: "",
          guests: "",
          occasion: "",
          venueType: "",
          name: "",
          phone: "",
        });
        setActiveStep(0);
      })
      .catch((err) => console.log("EmailJS Error:", err));
  };

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <>
            <Autocomplete
              freeSolo
              options={cities}
              value={formData.location}
              onChange={(event, val) => handleChange("location", val || "")}
              onInputChange={(event, val) =>
                handleChange("location", val || "")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Venue / Sector / City"
                  fullWidth
                  sx={{ mb: 3 }}
                />
              )}
            />

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Select Event Date"
                disabled={!formData.location}
                open={openCalendar}
                onOpen={() => setOpenCalendar(true)}
                onClose={() => setOpenCalendar(false)}
                value={formData.eventDate || null}
                onChange={(newValue) => {
                  handleChange("eventDate", newValue?.format("YYYY-MM-DD"));
                  setOpenCalendar(false);
                }}
                minDate={dayjs()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    placeholder="Pick a date"
                    onClick={() => formData.location && setOpenCalendar(true)}
                    sx={{ cursor: "pointer" }}
                  />
                )}
              />
            </LocalizationProvider>
          </>
        );

      case 1:
        return (
          <>
            <Typography fontWeight="600" mb={2}>
              Select the type of musical setup you prefer
            </Typography>
            <Typography variant="body2" mb={3}>
              This affects the overall sound, vibe & pricing.
            </Typography>

            <RadioGroup
              value={formData.bandSetup}
              sx={{ alignItems: "flex-start" }}
              onChange={(e) => handleChange("bandSetup", e.target.value)}
            >
              {[
                "Solo Performance",
                "Duo Setup",
                "Trio Ensemble",
                "Full Band",
              ].map((item) => (
                <FormControlLabel
                  key={item}
                  value={item}
                  control={<Radio />}
                  label={item}
                />
              ))}
            </RadioGroup>
          </>
        );

      case 2:
        return (
          <>
            <Typography fontWeight="600" mb={2}>
              Indicate number of guests
            </Typography>
            <Typography variant="body2" mb={3}>
              Helps suggest the right sound setup.
            </Typography>

            <RadioGroup
              value={formData.guests}
              sx={{ alignItems: "flex-start" }}
              onChange={(e) => handleChange("guests", e.target.value)}
            >
              {[
                "Up to 20",
                "21 to 50",
                "51 to 80",
                "81 to 120",
                "121 to 200",
                "201 to 500",
                "More than 500",
              ].map((range) => (
                <FormControlLabel
                  key={range}
                  value={range}
                  control={<Radio />}
                  label={range}
                />
              ))}
            </RadioGroup>
          </>
        );

      case 3:
        return (
          <>
            <Typography fontWeight="600" mb={2}>
              Type of Event
            </Typography>
            <RadioGroup
              value={formData.occasion}
              sx={{ alignItems: "flex-start" }}
              onChange={(e) => handleChange("occasion", e.target.value)}
            >
              {[
                "Party at House",
                "Wedding",
                "Corporate Event",
                "Other Private Event",
                "Reception",
                "Customize Venue",
              ].map((item) => (
                <FormControlLabel
                  key={item}
                  value={item}
                  control={<Radio />}
                  label={item}
                />
              ))}
            </RadioGroup>
          </>
        );

      case 4:
        return (
          <>
            <Typography fontWeight="600" mb={2}>
              Choose your venue type
            </Typography>
            <RadioGroup
              value={formData.venueType}
              sx={{ alignItems: "flex-start" }}
              onChange={(e) => handleChange("venueType", e.target.value)}
            >
              {[
                "Living Room",
                "Open Air",
                "Small Party Hall",
                "Banquet Hall",
              ].map((item) => (
                <FormControlLabel
                  key={item}
                  value={item}
                  control={<Radio />}
                  label={item}
                />
              ))}
            </RadioGroup>
          </>
        );

      case 5:
        return (
          <>
            <TextField
              fullWidth
              label="Your Name"
              sx={{ mb: 3 }}
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
            <TextField
              fullWidth
              label="Phone Number"
              value={formData.phone}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 10) {
                  handleChange("phone", value);
                }
              }}
              inputProps={{
                maxLength: 10,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/search-artists",
          label: "Search Artists",
          color: "info",
        }}
        md
        dark
      />

      <Box sx={{ display: "flex", justifyContent: "center", pt: 14 }}>
        <MKBox
          component="img"
          src={rockBand}
          alt="rockBand"
          width={{ xs: "80%", sm: "40%", md: "25%" }}
          height="100%"
          loading="lazy"
          sx={{ objectFit: "cover", display: "block" }}
        />
      </Box>

      {/* FIXED RESPONSIVE WIDTH */}
      <Container maxWidth="sm" sx={{ px: { xs: 2, sm: 0 } }}>
        <Box
          sx={{
            textAlign: "center",
            width: { xs: "100%", sm: "80%", md: "60%" },
            mx: "auto",
          }}
        >
          <Typography variant="h4" fontWeight="bold" mb={3}>
            Search Artist for Your Event
          </Typography>

          {/* FIXED STEPPER */}
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={{
              mb: 4,
              "& .MuiStepLabel-label": {
                typography: { xs: "caption", sm: "body2" },
              },
              "& .MuiStepConnector-line": {
                minHeight: { xs: 20, sm: 40 },
              },
            }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <Box>{renderStepContent()}</Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
            {activeStep !== 0 && (
              <Button
                variant="outlined"
                onClick={handleBack}
                sx={{ color: "blue" }}
              >
                Back
              </Button>
            )}

            <Button
              variant="contained"
              sx={{ color: "#fff" }}
              onClick={
                activeStep === steps.length - 1 ? handleSubmit : handleNext
              }
            >
              {activeStep === steps.length - 1 ? "Submit" : "Next"}
            </Button>
          </Box>
        </Box>
      </Container>

      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
      <Slide direction="left" in={success} unmountOnExit>
        <MKBox position="absolute" top="7.5rem" right={0} width="100%">
          <MKAlert
            width="85%"
            mx="auto"
            color="info"
            sx={{
              minHeight: "2.5rem !important",
              py: 1,
              justifyContent: "center",
            }}
            style={{ zIndex: 999999 }}
          >
            <MKTypography variant="body2" color="white" fontWeight="regular">
              🎉 Thank you! We will contact you soon!
            </MKTypography>
          </MKAlert>
          {/* <MKAlert color="info" style={{zIndex:999999}}>🎉 Thank you! We will contact you soon!</MKAlert> */}
        </MKBox>
      </Slide>
    </>
  );
};

export default SearchArtists;
